import React, { useState } from "react";
import { appShareTextString, getDeviceType } from "../helper";
import Share from "./Share";

const NativeShare = (props) => {
  const [share, setShare] = useState(false);
  const handleNativeShare = async () => {
    let title =
      "I just directly wrote to PM Modi to ask for exam advice. Got a question? Ask now through the Warriors Hotline! Exam Warriors can connect directly via the NaMo App #PPC2024";
    let url = "https://www.narendramodi.in/ppc_dm_to_pm";
    // let image = "";
    let data = {
      title: "Pariksha Pe Charcha 2023",
      text: title,
      url: url,
    };
    console.log("data ", data);

    // setShare(true);

    // return false;

    try {
      if (window.location.href.indexOf("appversionandroid") > -1) {
        //indexOf appversion

        try {
          let obj = {
            platform: getDeviceType(),
          };
          window.gtag("event", "native_share", obj);
        } catch (error) {}
        var sharelink = `appshare://text=${url} ${appShareTextString(title)}`;
        // alert(sharelink);

        window.location.href = sharelink;
      } else {
        if (navigator && navigator.canShare && navigator.canShare(data)) {
          try {
            let obj = {
              platform: getDeviceType(),
            };
            window.gtag("event", "native_share", obj);
          } catch (error) {}

          // document.getElementById("preloader_mantra").style.display = "block";

          // $(".preloader_bg").hide();
          navigator
            .share(data)
            .then(() => {
              console.log("Successfully native shared data");
            })
            .catch((error) => {
              console.log("Error native sharing", error);
              props.getShare();
              // if (ref.state.sharePopup) {
              //   ref.showSharePopup();
              // }
            });
          // document.getElementById("preloader_mantra").style.display = "none";
        } else {
          let sharemsg = "Native share only work for latest brwoser";
          console.log("sharePopup...", sharemsg);
          props.getShare();
        }
      }
    } catch (e) {
      props.getShare();
    }
  };
  return (
    <>
      <span
        onClick={() => {
          handleNativeShare();
        }}
        data-toggle="modal"
        data-target="#share"
      >
        <img src="/images/share.png" />
        {props.sharenow ? "" : Share}
      </span>
    </>
  );
};

export default NativeShare;
